import { createFileRoute, redirect } from "@tanstack/react-router";
import { getAccessToken } from "@/shared/infrastructure/auth/token-storage";
import { OnboardingPage } from "@/modules/auth/presentation/pages/OnboardingPage";

export const Route = createFileRoute("/onboarding")({
  beforeLoad: () => {
    if (!getAccessToken()) {
      throw redirect({ to: "/register" });
    }
  },
  component: OnboardingPage,
});
